import { requestApi } from './helper';
import { invalidateDestinationList } from './destination';

export const SAVE_ORDER_STATUS = 'SAVE_ORDER';
export const SAVE_CHANGE_ORDER_STATUS = 'SAVE_CHANGE_ORDER';

export const saveOrderStatus = (orderStatus, dispatch) => {
    dispatch(invalidateDestinationList());

    return { type: SAVE_ORDER_STATUS, orderStatus };
};

export const saveChangeOrderStatus = (changeOrderStatus, dispatch) => {
    dispatch(invalidateDestinationList());

    return { type: SAVE_CHANGE_ORDER_STATUS, changeOrderStatus };
};

export const requestOrder = (order, errorCallback, successCallback) => {
    const requestProperties = {
        method: 'post',
        headers: {
            'Content-Type': undefined,
        },
        body: order,
    };

    return requestApi('/order', requestProperties, saveOrderStatus, errorCallback, successCallback);
};

export const requestChangeOrder = (changeOrder, errorCallback, successCallback) => {
    const requestProperties = {
        method: 'post',
        body: JSON.stringify(changeOrder),
    };

    return requestApi('/changeorder', requestProperties, saveOrderStatus, errorCallback, successCallback);
};



// WEBPACK FOOTER //
// ./src/actions/order.js